import React from 'react'

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import { MatchStatus } from 'protos'

import T from 'components/FormattedMessage'

import GameCardBottomInfoBar from '../GameCardBottomInfoBar'
import { MatchStatusToken } from 'lib/enumTranslations'

interface Props {
  status: MatchStatus
}

const styles = createStyles({
  status: {
    opacity: .5,
    fontSize: 10,
    fontWeight: 500,
    textTransform: 'uppercase',
  }
})

type InjectedProps = Props & WithStyles<typeof styles>

const GameCardBottomInfoBarDefault: React.SFC<InjectedProps> = ({
  classes,
  status,
}) => {
  return (
    <GameCardBottomInfoBar>
      <Grid alignItems="center" justify="center" direction="row" container>
        <Grid item>
          <Typography className={classes.status}>
            <T id={MatchStatusToken(status)} />
          </Typography>
        </Grid>
      </Grid>
    </GameCardBottomInfoBar>
  )
}

export default withStyles(styles)(GameCardBottomInfoBarDefault)
